import { CartAssignmentAdd } from '../CartAssignmentAdd';
import { FC, Dispatch, SetStateAction } from 'react';
import { Modal } from 'react-bootstrap';
import { typeCartAssignment, typeCartsDoc } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    cartsDoc: typeCartsDoc;
    closeModal: () => void;
    newAssignment: typeCartAssignment;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
};

export const CartCalendarModalAdd: FC<propsType> = ({
    cartsDoc, closeModal, newAssignment, setRefreshCounter
}) => {
    const isDarkMode = useGetIsDarkMode();

    return (
        <Modal show onHide={closeModal}>
            <Modal.Header closeButton className={isDarkMode ? 'bg-dark text-white' : ''}>
                <Modal.Title>Agregar Asignación</Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark text-white' : ''}>
                <CartAssignmentAdd
                    cartsDoc={cartsDoc}
                    closeModal={closeModal}
                    newAssignment={newAssignment}
                    setRefreshCounter={setRefreshCounter}
                />
            </Modal.Body>
        </Modal>
    )
}
